import React from 'react';

export const PreviewClickBlockerContext = React.createContext(() => {});
